import { TableCell, TableRow, styled } from "@mui/material";
import { handleCutStringHelper, handleDate, handleNumberHelper, handleParseList, handleStringHelper, handleSubjectStringHelper, numbersToString, selectStatusColorHelper } from "../../helpers/displayStringHelpers";
import { useEffect, useState } from "react";
import { THEME } from "../../config";
import StyledTooltip from "../Misc/StyledTooltip";

const TableRowImage = styled(TableRow)({});

const TableCellImageProperty = styled(TableCell)({
    padding: "6px",
    borderBottom: "none",
    fontWeight: "bold"
});

const TableCellImageValue = styled(TableCell)(() => ({
    padding: "6px",
    borderBottom: "none",
    maxWidth: "200px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
}));

interface IOverviewRowProps {
    color?: string;
    property?: string;
    tooltip?: string;
    value?: any;
    type?: "number" | "string" | "date" | "longstring" | "type" | "status" | "liveness" | "modality" | "decision" | "issue" | "number[]";
}

const OverviewRow: React.FC<IOverviewRowProps> = (props) => {
    const [color, setColor] = useState(THEME.palette.text.primary);

    useEffect(() => {
        if (props.type === "status") setColor(selectStatusColorHelper(props.value));
    }, [props.value, props.type]);

    const handleValue = () => {
        switch (props.type) {
            case "number":
                return props.value !== undefined ? handleNumberHelper(props.value) : "";
            case "string":
                return props.value !== undefined ? handleSubjectStringHelper(props.value) : "";
            case "date":
                return props.value !== undefined ? handleDate(props.value, false) : "";
            case "longstring":
                return props.value !== undefined ? props.value : "";
            case "decision":
                return handleCutStringHelper("DECISION_", props.value)
            case "issue":
                return handleParseList("ISSUE_", props.value)
            case "number[]":
                return numbersToString(props.value)
            case "type":
            case "status":
            case "liveness":
            case "modality":
                return handleStringHelper(props.value);
        }
    };

    return (
        <TableRowImage style={{ backgroundColor: props.color }}>
            <TableCellImageProperty>{props.property}</TableCellImageProperty>
            <StyledTooltip title={props.tooltip}>
                <TableCellImageValue
                    style={{ color: color, fontWeight: props.type === "status" ? "500" : "400" }}
                >
                    {handleValue()}
                </TableCellImageValue>
            </StyledTooltip>
        </TableRowImage>
    );
};

export default OverviewRow;
